import { render, staticRenderFns } from "./DetailsRating.vue?vue&type=template&id=41dcbe66&scoped=true&"
import script from "./DetailsRating.vue?vue&type=script&lang=js&"
export * from "./DetailsRating.vue?vue&type=script&lang=js&"
import style0 from "./DetailsRating.vue?vue&type=style&index=0&id=41dcbe66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcbe66",
  null
  
)

export default component.exports